import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiurl } from "@/Config/ApiConfig/ApiUrl";

export const resendOtpApi = createApi({
  reducerPath: "resendOtpApi",
  baseQuery: fetchBaseQuery({ baseUrl: import.meta.env.VITE_BASE_API_URL }),
  tagTypes: ["ResendOtp"],
  endpoints: (builder) => ({
    resendOtp: builder.mutation({
      query: ({ userId, otpType }) => ({
        url: apiurl.ResendOTP,
        method: "POST",
        body: {
          userId,
          OtpType: otpType, 
        },
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
      }),
      
      invalidatesTags: ["ResendOtp"],
    }),
  }),
});

export const { useResendOtpMutation } = resendOtpApi;
